import { z } from 'zod';

export const PricingSpecByIdFormSchema = (t) =>
  z
    .object({
      pricingSpecId: z.string(t).uuid({ message: t('INVALID_UUID') }),
    })
    .strict()
    .required();

export type PricingSpecByIdFormType = z.infer<ReturnType<typeof PricingSpecByIdFormSchema>>;
